import PropTypes from 'prop-types';

import { IS_MAC_OS } from 'src/lib/userAgent';

export const VoidNodeContent = ({ className, text, children }) => {
  /* Prevent Chromium from interrupting IME when moving the cursor
     1. span + inline-block
     2. div + contenteditable=false
  */
  return (
    <div
      className={className}
      contentEditable={false}
    >
      {IS_MAC_OS ? (
        // Mac OS IME https://github.com/ianstormtaylor/slate/issues/3490
        <>
          {children}
          {text}
        </>
      ) : (
        // Others like Android https://github.com/ianstormtaylor/slate/pull/5360
        <>
          {text}
          {children}
        </>
      )}
    </div>
  );
};

VoidNodeContent.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
};

VoidNodeContent.defaultProps = {
  className: '',
  children: null,
};
